import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const AboutChild_About = (props) => {
  return (
    <>
      <div className="personal-info">
        <h2 className="m-0 mb-3">Personal Info</h2>
        <div className="mb-3">
          I specialize in building <b>responsive and interactive web interfaces</b> using modern frontend technologies. My portfolio showcases <b>Single Page Applications (SPA), Progressive Web Apps (PWA), and e-commerce platforms</b> that combine <b>beautiful design with excellent performance</b>. I focus on creating <b>scalable, maintainable, and user-centric solutions</b> that follow <b>industry best practices</b>.
        </div>
        <div className="mb-3">
          My technical expertise includes <b>React.js, Next.js, Redux Toolkit, JavaScript (ES6+), TypeScript, Tailwind CSS, and SCSS</b>. I excel at <b>component architecture, state management, performance optimization, and responsive design</b>. I'm passionate about writing <b>clean, efficient code</b> and delivering exceptional user experiences across all devices and browsers.
        </div>
        <Row>
          <Col className="skill-right-slider mb-3" md={6}>
            <div style={{ background: "#fff" }} className="skill-one">
              <div className="skill-icon">Email</div>
              <h6>
                <Link
                  to={`mailto:${"prakash.1992dev@gmail.com"}`}
                  className="text-decoration-none"
                >
                  {"prakash.1992dev@gmail.com"}
                </Link>
              </h6>
            </div>
          </Col>
          <Col className="skill-right-slider mb-3" md={6}>
            <div style={{ background: "#fff" }} className="skill-one">
              <div className="skill-icon">Phone</div>
              <h6>
                <Link to={`tel:${8866808798}`} className="text-decoration-none">
                  8866808798
                </Link>
              </h6>
            </div>
          </Col>
          <Col className="skill-right-slider mb-3" md={6}>
            <div style={{ background: "#fff" }} className="skill-one">
              <div className="skill-icon">Address</div>
              <h6>
                <Link
                  to={`https://www.google.com/maps/place/Ahmedabad,+Gujarat/@23.0202434,72.5797426,11z/data=!3m1!4b1!4m6!3m5!1s0x395e848aba5bd449:0x4fcedd11614f6516!8m2!3d23.022505!4d72.5713621!16zL20vMDFkODhj?entry=ttu&g_ep=EgoyMDI1MDIxMi4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D"}`}
                  className="text-decoration-none"
                >
                  Ahmedabad, Gujarat, India
                </Link>
              </h6>
            </div>
          </Col>
          <Col className="skill-right-slider mb-3" md={6}>
            <div style={{ background: "#fff" }} className="skill-one">
              <div className="skill-icon">Follow</div>
              <Link
                to={`https://www.linkedin.com/in/pek-s-kumar-ba2636125/`}
                className="text-decoration-none"
                target="_blank"
              >
                <svg
                  viewBox="0 0 24 24"
                  height={20}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="#0077B5"
                    fillRule="evenodd"
                    d="M20.45175,20.45025 L16.89225,20.45025 L16.89225,14.88075 C16.89225,13.5525 16.86975,11.844 15.04275,11.844 C13.191,11.844 12.90825,13.2915 12.90825,14.7855 L12.90825,20.45025 L9.3525,20.45025 L9.3525,8.997 L12.765,8.997 L12.765,10.563 L12.81375,10.563 C13.2885,9.66225 14.4495,8.71275 16.18125,8.71275 C19.78575,8.71275 20.45175,11.08425 20.45175,14.169 L20.45175,20.45025 Z M5.33925,7.4325 C4.1955,7.4325 3.27375,6.50775 3.27375,5.36775 C3.27375,4.2285 4.1955,3.30375 5.33925,3.30375 C6.47775,3.30375 7.4025,4.2285 7.4025,5.36775 C7.4025,6.50775 6.47775,7.4325 5.33925,7.4325 L5.33925,7.4325 Z M7.11975,20.45025 L3.5565,20.45025 L3.5565,8.997 L7.11975,8.997 L7.11975,20.45025 Z M23.00025,0 L1.0005,0 C0.44775,0 0,0.44775 0,0.99975 L0,22.9995 C0,23.55225 0.44775,24 1.0005,24 L23.00025,24 C23.55225,24 24,23.55225 24,22.9995 L24,0.99975 C24,0.44775 23.55225,0 23.00025,0 L23.00025,0 Z"
                  />
                </svg>
              </Link>
              <Link
                target="_blank"
                to={`https://github.com/Pekskumar`}
                className="text-decoration-none ms-2"
              >
                <svg
                  fill="#000000"
                  width="25px"
                  height="25px"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  data-name="Layer 1"
                >
                  <path d="M12,2.2467A10.00042,10.00042,0,0,0,8.83752,21.73419c.5.08752.6875-.21247.6875-.475,0-.23749-.01251-1.025-.01251-1.86249C7,19.85919,6.35,18.78423,6.15,18.22173A3.636,3.636,0,0,0,5.125,16.8092c-.35-.1875-.85-.65-.01251-.66248A2.00117,2.00117,0,0,1,6.65,17.17169a2.13742,2.13742,0,0,0,2.91248.825A2.10376,2.10376,0,0,1,10.2,16.65923c-2.225-.25-4.55-1.11254-4.55-4.9375a3.89187,3.89187,0,0,1,1.025-2.6875,3.59373,3.59373,0,0,1,.1-2.65s.83747-.26251,2.75,1.025a9.42747,9.42747,0,0,1,5,0c1.91248-1.3,2.75-1.025,2.75-1.025a3.59323,3.59323,0,0,1,.1,2.65,3.869,3.869,0,0,1,1.025,2.6875c0,3.83747-2.33752,4.6875-4.5625,4.9375a2.36814,2.36814,0,0,1,.675,1.85c0,1.33752-.01251,2.41248-.01251,2.75,0,.26251.1875.575.6875.475A10.0053,10.0053,0,0,0,12,2.2467Z" />
                </svg>
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AboutChild_About;
